import { Minus, Spline } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface PointTypeButtonProps {
  pointType: 'smooth' | 'corner'
  onPointTypeChange: (type: 'smooth' | 'corner') => void
  isHovered: boolean
  onHoverStart: () => void
  onHoverEnd: () => void
  tooltipContainer: HTMLElement | null
}

/** Toggles new nodes between smooth (pen curve) and corner (smart point). */
export function PointTypeButton({
  pointType,
  onPointTypeChange,
  isHovered,
  onHoverStart,
  onHoverEnd,
  tooltipContainer,
}: PointTypeButtonProps) {
  return (
    <Tooltip open={isHovered}>
      <TooltipTrigger asChild>
        <button
          onClick={() => onPointTypeChange(pointType === 'smooth' ? 'corner' : 'smooth')}
          onPointerEnter={onHoverStart}
          onPointerLeave={onHoverEnd}
          className="flex h-9 w-9 flex-shrink-0 cursor-pointer items-center justify-center rounded-lg border-none p-0 text-[#1a1a1a] transition-colors hover:bg-black/[0.06]"
        >
          {pointType === 'smooth' ? <Spline className="h-4 w-4" /> : <Minus className="h-4 w-4" />}
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" container={tooltipContainer}>
        {pointType === 'smooth'
          ? 'Pen curve mode — click for smart point'
          : 'Smart point mode — click for pen curve'}
      </TooltipContent>
    </Tooltip>
  )
}
